// extracted by mini-css-extract-plugin
module.exports = {"menu":"ActionsPopup_menu__yZALq","menuItem":"ActionsPopup_menuItem__1WLvQ"};